export default "__VITE_ASSET__DTeRsPXb__"